import React, { useState } from "react";

interface Props {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const Dropdown: React.FC<Props> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <div
      style={{
        marginBottom: "1rem",
        border: "1px solid #ccc",
        borderRadius: "6px",
      }}
    >
      <div
        onClick={toggleOpen}
        style={{
          padding: "10px 15px",
          backgroundColor: "#f7f7f7",
          cursor: "pointer",
          fontWeight: 600,
          fontSize: "16px",
        }}
      >
        {title} {isOpen ? "▲" : "▼"}
      </div>
      {isOpen && <div style={{ padding: "10px 15px" }}>{children}</div>}
    </div>
  );
};

export default Dropdown;
